import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DropdownBox from "./DropdownBox";
const StatusEditForm = ({
  type,
  currentStatus,
  setEditing,
  statuses,
  handleSaveStatus,
  Id,
  requireStatusNote = true,
}) => {
  const [statusNote, setStatusNote] = useState("");
  const [status, setStatus] = useState(currentStatus);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleSave = async () => {
    if (status === currentStatus) {
      toast.info("No changes detected.");
      return;
    }

    if (!statusNote && requireStatusNote) {
      toast.error("Status note required.");
      return;
    }

    setIsUpdating(true);

    try {
      await handleSaveStatus(Id, status, statusNote);
      // console.log("Status updated:", { status, Id, statusNote });
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status. Please try again.");
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="bg-white rounded-md">
      <hr className="mb-3" />
      <div className="mb-4">
        <div className="flex justify-between items-center mb-2 ">
          <p className="font-medium text-base text-text2">
            {type && `${type}`} Status
          </p>
          <div className="flex space-x-2">
            <button
              onClick={() => setEditing(false)}
              className="px-4 py-1 border border-gray-300 rounded-full text-xs font-semibold focus:outline-none focus:ring-0"
              disabled={isUpdating}
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className={`px-3 py-0.5 ${
                isUpdating ? "bg-gray-400" : "bg-primary"
              } text-text1 rounded-full text-xs font-semibold focus:outline-none focus:ring-0`}
              disabled={isUpdating}
            >
              {isUpdating ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
        <div className="bg-[#F9FAFB] p-3 rounded-md">
          <div className="mb-4 flex justify-between">
            <div>
              <div className="text-base text-text1 mb-2 font-medium">
                Update status
              </div>
              <div className="text-sm text-gray-500 mb-2 font-normal">
                Check and update the status.
              </div>
            </div>

            <div className="relative flex h-[44px]">
              <DropdownBox
                optionList={statuses}
                styleName="rounded-md text-sm font-normal text-text1 uppercase focus:outline-none focus:ring-0  mt-1 min-w-32 py-2 px-2"
                value={status}
                handleChange={(selectedValue) => setStatus(selectedValue)}
              />
            </div>
          </div>

          <div>
            <div className="text-sm text-[#374151] mb-1 font-medium">Note</div>
            <textarea
              value={statusNote}
              onChange={(e) => setStatusNote(e.target.value)}
              placeholder="Enter your message here..."
              className="w-full px-3 py-2 border border-gray-300 rounded-md h-24 resize-none bg-white relative text-[#374151] focus:outline-none focus:ring-0"
              disabled={isUpdating}
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusEditForm;
